import { Component, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LoginService } from 'src/app/services/login.service';
import { UserComponent } from './user/user.component';
import { UsersInfoV2Service } from 'src/app/services/user-info.service';
import { catchError, filter, switchMap, tap } from 'rxjs/operators';
import { Subscription, throwError } from 'rxjs';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss'],
})
export class UsersComponent implements OnDestroy {
  isAvailableNewUser = false;
  private subs = new Subscription();

  constructor(
    private dialog: MatDialog,
    private loginService: LoginService,
    private userInfoService: UsersInfoV2Service
  ) {}

  onSetUser(userId?: number) {
    this.subs.add(
      this.userInfoService
        .getAvailableInfo()
        .pipe(
          tap((isAvailable) => {
            !isAvailable &&
              this.loginService.showMessage(
                'Quantidade de usuários já foi atingida!',
                3000
              );
          }),
          filter((isAvailable) => !!isAvailable),
          switchMap(() => this.openModal(userId)),
          catchError((error) => {
            this.loginService.showMessage(
              'Não foi possível acessar os dados da conta, tente novamente!'
            );
            return throwError(error);
          })
        )
        .subscribe()
    );
  }

  openModal(userId?: number) {
    const dialogRef = this.dialog.open(UserComponent, {
      disableClose: true,
      data: {
        id: userId ?? 'novo',
      },
    });

    return dialogRef.afterClosed();
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
